import React, {Component} from 'react';
import {getParams} from "../../../utils/functions";
import * as func from "../../../utils/functions";
import Arrow from "./module/arrow"
import Loading from "../../etc/loading";
import {IMPORT_STATUS_NAME} from "../../../wpconfig";

class IDetail extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isInit: false,
			param: {
				type: getParams('type') ? getParams('type') : 'wos',
				record_id: getParams('record_id'),
				ids: [],
				sync_ids: [],
			},
			record: {
				'progress_status': 'parse'
			},
			records: [],
			action: 'admin/import/',
			isLoading: false,
			allCheck: false,
			allSyncCheck: false,
			totalCount : 0,
			syncCount : 0
		}

		this.action = this.action.bind(this)
	}

	componentDidMount() {
		func.getData(this.state.action + 'detail', this.state.param).then((response) => {
			if (response) {
				let syncCount = 0
				let totalCount = 0
				response.records.map((record, index) => {
					if(record.artificial && record.artificial.duplicate_resource)
						if(record.artificial.duplicate_resource.resource_id)
							syncCount++
						else
							totalCount++
					else
						totalCount++
				})
				this.setState({
					isInit: true,
					record: response.record,
					records: response.records,
					syncCount : syncCount,
					totalCount : totalCount
				});
			} else {
				this.setState({
					isInit: true
				});
			}
		});
	}

	action = (action) => {
		event.preventDefault()

		if (this.state.record.progress_status === 'verify' && action === 'sync') {
			if(this.state.param.sync_ids.length <= 0) {
				alert('선택후 동기화해주세요.'); return;
			}

			func.updateFile(this.state.action + action, this.state.param).then((response) => {
				func.getData(this.state.action + 'detail', this.state.param).then((response) => {
					if (response) {
						this.setState({
							isLoading: false,
							record: response.record,
							records: response.records,
						});
						this.forceUpdate()
					}
				});
			});
		} else if (
			(this.state.record.progress_status === 'parse' && action === 'artificial')
			|| (this.state.record.progress_status === 'artificial' && action === 'verify')
			|| (this.state.record.progress_status === 'verify' && action === 'import')
			|| (this.state.record.progress_status === 'import' && action === 'import')
		) {
			if (action === 'import') {
				if (this.state.param.ids.length <= 0) {
					alert('선택후 반입해주세요.'); return;
				}
			}
			this.setState({
				isLoading: true
			})

			func.updateFile(this.state.action + action, this.state.param).then((response) => {
				func.getData(this.state.action + 'detail', this.state.param).then((response) => {
					if (response) {
						this.setState({
							isLoading: false,
							record: response.record,
							records: response.records,
							ids: [],
							sync_ids: [],
						});
						this.forceUpdate()
					}
				});
			});
		}
	}

	onAllCheck = (event) => {
		let param = this.state.param
		let ids = []
		if (event.target.checked) {
			this.state.records.map((record, index) => {
				if (record.doc_id) {
					if(!record.artificial.error_doc) {
						if (record.artificial && record.artificial.duplicate_resource) {
							if (record.artificial.duplicate_resource.resource_id) {
							} else {
								ids.push(record.doc_id)
							}
						} else {
							ids.push(record.doc_id)
						}
					}
				}
			})
		}
		param.ids = ids

		// 000726960100001
		console.log(param)
		this.setState({
			param: param,
			allCheck: event.target.checked
		})
		this.forceUpdate()
	}

	onSyncAllCheck = (event) => {
		let param = this.state.param
		let sync_ids = []
		if (event.target.checked) {
			this.state.records.map((record, index) => {
				if(record.artificial && record.artificial.duplicate_resource)
					if(record.artificial.duplicate_resource.resource_id)
						sync_ids.push(record.doc_id)
			})
		}
		param.sync_ids = sync_ids

		this.setState({
			param: param,
			allSyncCheck: event.target.checked
		})
	}

	onCheck = (event) => {
		let param = this.state.param
		let ids = param.ids
		if (event.target.value) {
			if (event.target.checked) {
				if (ids.includes(event.target.value)) {
				} else {
					ids.push(event.target.value)
				}
			} else {
				if (ids.includes(event.target.value)) {
					const idx = ids.indexOf(event.target.value)
					if (idx > -1) ids.splice(idx, 1)
				} else {
				}
			}
		}
		param.ids = ids
		let allCheck = false
		if (param.ids.length === this.state.records.length)
			allCheck = true

		this.setState({
			param: param,
			allCheck: allCheck
		})
		this.forceUpdate()
	}

	onSyncCheck = (event) => {
		let param = this.state.param
		let sync_ids = param.sync_ids
		if (event.target.value) {
			if (event.target.checked) {
				if (sync_ids.includes(event.target.value)) {
				} else {
					sync_ids.push(event.target.value)
				}
			} else {
				if (sync_ids.includes(event.target.value)) {
					const idx = sync_ids.indexOf(event.target.value)
					if (idx > -1) sync_ids.splice(idx, 1)
				} else {
				}
			}
		}
		param.sync_ids = sync_ids
		let allSyncCheck = false
		if (param.sync_ids.length === this.state.syncCount)
			allSyncCheck = true

		this.setState({
			param: param,
			allSyncCheck: allSyncCheck
		})
		this.forceUpdate()
	}

	render() {

		return (
			<>
				<table className="table table-striped table-thin border-bottom mt-4">
					<colgroup>
						<col width="200px"/>
						<col width="80px"/>
						<col width=""/>
						<col width="80px"/>
						<col width="80px"/>
						<col width="80px"/>
						<col width="150px"/>
						<col width="100px"/>
					</colgroup>
					<thead>
					<tr>
						<th scope="col">작업 ID</th>
						<th scope="col">유형</th>
						<th scope="col">파일명</th>
						<th scope="col">전체</th>
						<th scope="col">중복</th>
						<th scope="col">에러</th>
						<th scope="col">반입일자</th>
						<th scope="col">상태</th>
					</tr>
					</thead>
					<tbody>
					<tr>
						<td>{this.state.record.unique_id}</td>
						<td>{this.state.record.resource_type}</td>
						<td>{this.state.record.file_name}</td>
						<td>{this.state.record.row_count}</td>
						<td>{this.state.record.dup_count}</td>
						<td>{this.state.record.err_count}</td>
						<td>{func.getDateYMD(this.state.record.input_date)}</td>
						<td>업로드</td>
					</tr>
					</tbody>
				</table>

				{this.state.isLoading ? <Loading/> :
					<div className="container mt-5">
						<div>
							<div className="d-flex justify-content-center mb-4">
								<div className="row align-middle">
									<div
										className={"circle d-inline-block"
										+ (this.state.record.progress_status === 'parse' ? ' active' : '')}>업로드
									</div>

									<div className="align-self-center">
										<Arrow/>
									</div>

									<div
										className={"circle d-inline-block"
										+ (this.state.record.progress_status === 'artificial' ? ' active' : '')}
										onClick={() => this.action('artificial')}>변환

									</div>

									<div className="align-self-center">
										<Arrow/>
									</div>

									<div className={"circle d-inline-block"
									+ (this.state.record.progress_status === 'verify' ? ' active' : '')
									+ (this.state.record.progress_status === 'artificial' ? ' next-step' : '')}
										 onClick={() => this.action('verify')}>검증
									</div>

									<div className="align-self-center">
										<Arrow/>
									</div>

									<div className={"circle d-inline-block"
									+ (this.state.record.progress_status === 'import' ? ' active' : '')
									+ (this.state.record.progress_status === 'verify' ? ' next-step' : '')}
										 onClick={() => this.action('import')}>반입
									</div>
								</div>
							</div>
						</div>
						<div>
							<div className="d-flex justify-content-center mt-2 mb-4">
								<p className="text-danger">실행 후 변화가 없을 경우, 페이지 새로고침을 눌러주세요(버튼 재실행 금지).</p>
							</div>
						</div>

					</div>
				}

				{(this.state.record.progress_status === 'import' || this.state.record.progress_status === 'verify') &&
				<>
					<button className="btn btn-outline-primary btn-sm" onClick={() => this.action('sync')}>중복 레코드 동기화</button>

					<table className="table table-striped table-thin border-bottom mt-1 rm-import-detail">
						<thead>
						<tr>
							<th scope="col">
								<input type="checkbox" className="ml-0" checked={this.state.allCheck}
								       onChange={this.onAllCheck}/>
							</th>
							<th scope="col">논문유형</th>
							<th scope="col">ID</th>
							<th scope="col">중복확인
								<p className="m-0 p-0">
									<label className="m-0">
										<input type="checkbox" className="ml-0" checked={this.state.allSyncCheck}
										  onChange={this.onSyncAllCheck}/>전체
									</label>
								</p>
							</th>
							<th scope="col">논문명</th>
							<th scope="col">DOI</th>
							<th scope="col">저널명</th>
							<th scope="col">기관수</th>
							<th scope="col">저자수</th>
							<th scope="col">부산대<br/>저자수</th>
							<th scope="col">연구자<br/>매핑</th>
							<th scope="col">연구자<br/>미처리</th>
							<th scope="col">상태</th>
							<th scope="col">입력일</th>
						</tr>
						</thead>
						<tbody>
						{this.state.records && this.state.records.map((record, index) => {
							const checked = record.doc_id && this.state.param.ids.includes(record.doc_id) ? true : false
							const sync_checked = record.doc_id && this.state.param.sync_ids.includes(record.doc_id) ? true : false

							return (
								<tr key={index}>
									<td>{!record.artificial.error_doc &&
										<input type="checkbox" className="ml-0"
											   checked={checked} onChange={this.onCheck}
											   value={record.doc_id}/>
									}
									</td>
									<td>{record.artificial.resource_type}</td>
									<td>
										{record.doc_id}
									</td>
									<td>
										{!record.artificial.error_doc && record.artificial.duplicate_resource.resource_id ?
											<>
												<a href={"/scholar/wp-admin/admin.php?page=resource&record_id=" + record.artificial.duplicate_resource.resource_id}
													target="_blank">
													{record.artificial.duplicate_resource.resource_id}</a>
													<br/>
													<label><input type="checkbox" className="ml-0"
													       checked={sync_checked} onChange={this.onSyncCheck}
													       value={record.doc_id}/>동기화</label>
												</>
											: ''
										}
									</td>
									<td>{record.artificial.error_doc ? "에러발생(확인 후 수동입력)" : record.artificial.resource_title }
									</td>
									<td>{record.artificial.doi && <a href={"http://dx.doi.org/" + record.artificial.doi} target="_blank">{record.artificial.doi}</a>}</td>
									<td>{record.artificial.journal_title}</td>
									<td>{record.meta_data ? record.meta_data.affi_count : '0'}</td>
									<td>{record.meta_data ? record.meta_data.author_count : '0'}</td>
									<td>{record.meta_data ? record.meta_data.scholar_count + record.meta_data.scholar_undefined_count : '0'}</td>
									<td>{record.meta_data ? record.meta_data.scholar_count : ''}</td>
									<td>{record.meta_data ? record.meta_data.scholar_undefined_count : ''}</td>
									<td>{IMPORT_STATUS_NAME[record.progress_status]}</td>
									<td>{func.getDateYMD(record.input_date)}</td>
								</tr>
							)
						})}
						</tbody>
					</table>
				</>
				}
			</>
		)
	}
}

export default IDetail;
